import * as React from 'react';
import {useEffect, useState} from "react";
import {DashboardSolution} from "../data/entities/DashboardSolution";
import {SolutionType} from "../data/SolutionDataSource";
import {Bundle, IBundle} from "../data/BundleData";
import {PageEnums} from "./nav/PageEnums";
import {UIState} from "../data/UIState";
import {BoothPageContent} from "./booth/BoothPageContent";
import {VideoCollection} from "./videocollection/VideoCollection";
import {SecondaryBar} from "./widgets/SecondaryBar";
import {PrimaryLayout} from "./widgets/PrimaryLayout";
import {Library} from "./library/Library";
import {RegisteredStatusBox} from "./widgets/RegisteredStatusBox";
import {observer} from "mobx-react";
import {JoinLiveButtonBox} from "./widgets/JoinLiveButtonBox";

import './SolutionDetailPage.pcss';
import {OnSiteHealthFair} from "./onsite-health-fair/OnSiteHealthFair";
import {handleSpacePressed} from "utils";
import {BottomBackButton} from "components/widgets/BottomBackButton";

interface Props {
  dashboardSolution:DashboardSolution|null;
}

export function SolutionDetail(props:Props) {
  if(null==props.dashboardSolution) {
    return <button onClick={()=>{ UIState.currentPage = PageEnums.dashboard; }}>BACK TO DASHBOARD</button>
  } else {
    return <_SolutionDetail dashboardSolution={props.dashboardSolution} />
  }
}

const _SolutionDetail = observer((props:{dashboardSolution:DashboardSolution}) => {
  const [selectedBundle, setSelectedBundle] = useState<Bundle|null>(null);
  const solution = UIState.feedData.solution;

  useEffect(() => {
      if (1 === solution.bundles.length) {
        setSelectedBundle(new Bundle(solution.bundles[0]));
      }
    }, []
  );

  function handleSelectBundle(iBundle:IBundle) {
    if(iBundle) {
      setSelectedBundle(new Bundle(iBundle));
    } else {
      setSelectedBundle(null);
    }
  }

  let backToDashboard = false;
  if(solution) {
    if (1===solution.bundles.length || null===selectedBundle) {
      backToDashboard = true;
    }
  } else {
    backToDashboard = true;
  }

  function handleBack() {
    if(backToDashboard) {
      UIState.currentPage = PageEnums.dashboard;
    } else {
      setSelectedBundle(null);
    }
  }

  // Loading or failure state
  if(null==solution) {
    return (
      <div className={""}>
        <SecondaryBar title={""} subTitle={""} buttonAction={handleBack} />
      </div>
    );
  }
  // success state
  else {

    // If this solution has a single bundle, then
    // go directly to that bundle
    if(selectedBundle){
      const zoomRegistration = selectedBundle.zoomRegistration; //UIState.user.zoomRegistrationForBundleId(selectedBundle._id);
      const liveEvent = selectedBundle.liveEvent; // LiveEventData.liveEventForBundleId(selectedBundle._id);

      let topRightContent:any = null;
      if(liveEvent && liveEvent.live && zoomRegistration) {
        topRightContent = <JoinLiveButtonBox bundle={selectedBundle} zoomRegistration={zoomRegistration} />;
      } else if(!solution.alwaysAvailable) {
        // this indicates that there was a live event that required registration,
        // and now it is over.
        if(zoomRegistration && !liveEvent) {
          topRightContent = "";
        }
        else {
          // display the registered box if this is a single solution
          if(1===solution.bundles.length && !solution.autoRegister) {
            topRightContent = <RegisteredStatusBox eventName={selectedBundle.fullName} />;
          } else {
            topRightContent = "";
          }
        }
      }
      const solutionBundleIdx = solution.solutionBundles.findIndex(sb=>sb.bundleId===selectedBundle._id);
      const solutionBundle = -1!==solutionBundleIdx ? solution.solutionBundles[solutionBundleIdx] : undefined;

      const backLabel = `Back to ${backToDashboard?'Dashboard':solution.name}`;
      return (
        <PrimaryLayout className={`bundle ${selectedBundle.type}`}>
          <SecondaryBar
            title={selectedBundle.fullName}
            subTitle={selectedBundle.subTitle}
            buttonAction={handleBack}
            buttonLabel={backLabel}
          >
            {topRightContent}
          </SecondaryBar>
          <BoothPageContent
            booth={selectedBundle}
            singleBundleDashboardSolution={solution.bundles.length===1?props.dashboardSolution:undefined}
            solutionBundle={solutionBundle}
            feedData={UIState.feedData}
            user={UIState.user}
          />
          <BottomBackButton backLabel={backLabel} onClick={handleBack} />
        </PrimaryLayout>
      );
    }
    else {
      // On-Demand Videos
      if(solution.type===SolutionType.VIDEOS) {
        return <VideoCollection
            solution={solution}
            feedItems={UIState.feedData.feed}
            onSelectBundle={handleSelectBundle}
            onBack={handleBack}
            dashboardSolution={props.dashboardSolution}
        />;
      }
      // Library
      else if(solution.type===SolutionType.LIBRARY) {
        return <Library
            solution={solution}
            onSelectBundle={handleSelectBundle}
            onBack={handleBack}
        />;
      }
      else if(solution.type===SolutionType.ONSITE_HEALTH_FAIR) {
        return <OnSiteHealthFair
            solution={solution}
            solutionCurrentPoints={UIState.feedData.pointsDataSource.points}
            feedItems={UIState.feedData.feed}
            onSelectBundle={handleSelectBundle}
            onBack={handleBack}
            dashboardSolution={props.dashboardSolution}

        />;
      }

      // Otherwise, display an overview page
      // TODO: Build the UI for this
      else {
        return (
          <div>
            <button onClick={handleBack}>BACK</button>
            <p>Multi-bundle template for "{solution.type}" not yet implemented.</p>
            <ul>
              {solution.bundles.map(bundle=><li key={bundle._id}>
                <a
                  onClick={()=>{  handleSelectBundle(bundle);  }}
                  onKeyDown={(e)=>{ handleSpacePressed(e, ()=>{  handleSelectBundle(bundle);  });}}
                >{bundle.fullName}</a>
              </li>)}
            </ul>
          </div>
        );
      }
    }

  }

})
